<ng-container *ngIf="iconConfig">
	<ng-container *ngIf="!iconConfig.displayEmpty; else emptyTemplate">
		<mat-icon *ngIf="iconConfig.iconName; else spinner" (click)="$event.preventDefault(); evtClick();"
			[ngClass]="'copo-datacenter-grid-icon-16' + (iconConfig.className ? ' ' + iconConfig.className : '') + (isClickable() ? ' copo-offer-cursor-pointer' : '')"
			[svgIcon]="iconConfig.iconName"
			[matTooltip]="iconConfig.toolTipText ? iconConfig.toolTipText : ''"></mat-icon>

		<ng-template #spinner>
			<mat-progress-spinner diameter="16" strokeWidth="2" color="warn" mode="indeterminate" class="spinner-icon">
			</mat-progress-spinner>
		</ng-template>
	</ng-container>

	<ng-template #emptyTemplate></ng-template>
</ng-container>